import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import { DashInfoBox } from "../../components/styledComponent/DashCount";
import DashCount from "../../components/dashboard/DashCount";
import { Skeleton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { useCrudForm } from "../../api/useCrudForm";
import { endpoints } from "../../api/endpoints";
import { toast } from "react-toastify";

const DashInfo = ({ isLoading, registerCount, visitCount, visitorCount }: any) => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [makerApproved, setMakerApproved] = useState(false);

    const { user } = useContext(AppContext);
    const { get, add } = useCrudForm();

    const requestSyncData = () => {
        setButtonLoading(true);
        add({
            endpoints: `${endpoints.lockerRenewTrigger.renew}`,
            onSuccess: (res: any) => {
                setButtonLoading(false);
                toast.success(res?.message, { style: { background: '#3150A1' } });
                setMakerApproved(true)
            },
            onError: (error: any) => {
                setButtonLoading(false);
                toast.error(error?.message ?? error)
            },
            values: { isMakerApproved: true }
        })
    }

    const approveSyncData = () => {
        setButtonLoading(true);
        get({
            endpoints: `${endpoints.lockerCharge.renewViaTrigger}`,
            onSuccess: (res: any) => {
                setButtonLoading(false);
                toast.success(res?.message, { style: { background: '#3150A1' } });
                setMakerApproved(false)
            },
            onError: (error: any) => {
                setButtonLoading(false);
                toast.error(error?.message ?? error)
            }
        })
    }

    const checkStatus = () => {
        get({
            endpoints: `${endpoints.lockerRenewTrigger.check}`,
            onSuccess: (res: any) => {
                setMakerApproved(res?.data?.isMakerApproved)
            },
            onError: (error: any) => {
                toast.error(error);
            }
        })
    }

    useEffect(() => {
        checkStatus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ background: "white", borderRadius: "5px", padding: "20px", flexGrow: "1", marginTop: "12px" }}>
            <Typography component="p" mb={1}>Today</Typography>
            <DashInfoBox>
                {
                    isLoading ? <>
                        <Skeleton variant="text" height={100} width={180} />
                        <Skeleton variant="text" height={100} width={180} />
                        <Skeleton variant="text" height={100} width={180} />
                        <Skeleton variant="text" height={100} width={180} />
                    </> : <>
                        <DashCount
                            icon={<CalendarViewMonthIcon sx={{ color: "white", fontSize: "30px" }} />}
                            color="rgba(47, 128, 237, 1)"
                            title="Visit Count"
                            value={visitCount}
                            chip={{ value: "2%", progress: true }}
                        />
                        <DashCount
                            icon={<GroupOutlinedIcon sx={{ color: "white", fontSize: "30px" }} />}
                            color="rgba(111, 207, 151, 1)"
                            title="Visitors"
                            value={visitorCount}
                            chip={{ value: "4%", progress: true }}
                        />

                        <DashCount
                            icon={<PersonAddAlt1OutlinedIcon sx={{ color: "white", fontSize: "30px" }} />}
                            color="rgba(151, 71, 255, 1)"
                            title="New Registrations"
                            value={registerCount}
                            chip={{ value: "5%", progress: false }}
                        />

                        {
                            (user?.role).toLowerCase() === 'maker' && !makerApproved ? <LoadingButton loading={buttonLoading ?? false} onClick={() => requestSyncData()} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '120px', height: '40px' }}>Sync Data</LoadingButton> : null
                        }
                        {
                            makerApproved && ((user?.role).toLowerCase() === 'checker' || (user?.role).toLowerCase() === 'admin') ? <LoadingButton loading={buttonLoading ?? false} onClick={() => approveSyncData()} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '180px', height: '40px' }}>Approve sync</LoadingButton> : null
                        }
                    </>
                }
            </DashInfoBox>
        </Box>
    );
}

export default DashInfo;